module.exports = __webpack_public_path__ + "img/Hellio_120X35.74fae7a6.png";